import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'

import { StyledButton } from 'components/shared'

import ErrorIcon from 'svgs/alert.svg'

export default function SignUpForm() {
  const baseInputStyles = `border-2 border-white w-full py-4 px-4 rounded my-3 placeholder:text-[#6F6060] text-[18px] text-black outline-none outline-2 focus:outline-gold border-0`
  const errorStyles = `!border-red-600  !outline-none !outline-0 !focus:outline-black`
  const [submitted, setSubmitted] = useState(false)
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: 'onSubmit',
  })
  const onSubmit = async (data, e) => {
    e.preventDefault()
    if (data.itsatrap) {
      window.location.replace(
        'https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley'
      )
    } else {
      sendMail(data, setSubmitted)
    }
  }

  useEffect(() => {
    if (submitted) {
      console.log(`Form is submitted 🚀`)
      document.getElementById('form').reset()
    }
  }, [submitted])

  return (
    <div className="bg-black">
      <div className="w-11/12 mx-auto container text-center py-12 md:py-24">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          className="w-[90%] mx-auto max-w-[900px] "
          id="form"
        >
          <h2 className="text-[18px] font-normal leading-normal md:text-[22px] xl:text-[28px]">
            Join our mailing list for updates and special offers.
          </h2>
          <input
            type="text"
            id="yourName"
            name="Name"
            placeholder="Your name here"
            className="sr-only"
            autoComplete="none"
            tabIndex="-1"
            {...register('itsatrap')}
          />
          <section className="md:flex md:gap-8">
            <input
              className={`${baseInputStyles} ${
                errors.firstName ? errorStyles : ''
              }`}
              type="text"
              name="firstName"
              placeholder="First Name*"
              {...register('firstName', {
                required: 'Your first name is required',
              })}
            />
            <input
              className={`${baseInputStyles} ${
                errors.lastName ? errorStyles : ''
              }`}
              type="text"
              name="lastName"
              placeholder="Last Name*"
              {...register('lastName', {
                required: 'Your last name is required',
              })}
            />
          </section>
          <section className="md:flex md:gap-8">
            <input
              className={`${baseInputStyles} ${
                errors.email ? errorStyles : ''
              } md:w-[65%]`}
              type="email"
              name="email"
              placeholder="Email*"
              {...register('email', {
                required: 'A email address is required',
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: 'Invalid email address',
                },
              })}
            />
            <StyledButton
              submit
              type="submit"
              text="SIGN ME UP"
              className="w-full py-4 px-2 mt-3 md:w-[35%] md:h-[62px]"
            />
          </section>
        </form>
        {Object.keys(errors).length === 0 ? (
          ''
        ) : (
          <div className="w-[90%] mx-auto my-5 flex flex-col gap-3 md:flex-row md:flex-wrap md:justify-center">
            {errors.firstName && (
              <ErrorMessage message={errors.firstName.message} />
            )}
            {errors.lastName && (
              <ErrorMessage message={errors.lastName.message} />
            )}
            {errors.email && <ErrorMessage message={errors.email.message} />}
          </div>
        )}
      </div>
      <SuccessModal submitted={submitted} setSubmitted={setSubmitted} />
    </div>
  )
}

const SuccessModal = ({ submitted, setSubmitted }) => {
  useLayoutEffect(() => {
    setTimeout(() => {
      if (submitted) {
        console.log('timer')
        setSubmitted(!submitted)
      }
    }, 3500)
  }, [submitted])

  return (
    <div
      className={`fixed z-[9999] bottom-0 left-0 w-full transition 	${
        submitted ? 'opacity-1 translate-y-[0rem]' : ' translate-y-[10rem]'
      }`}
    >
      <div className="w-[90%] mx-auto bg-white rounded mb-4 text-center max-w-[315px] md:mr-auto md:ml-8 md:mb-8">
        <div className="p-3 text-black flex items-center  m-0">
          <p className="m-0 p-0 text-lg">
            <span className="font-bold uppercase text-green-700">Success:</span>{' '}
            Thank you for signing up.
          </p>
        </div>
      </div>
    </div>
  )
}
const ErrorMessage = ({ message }) => (
  <div className="flex items-center justify-center rounded p-3 gap-3 bg-red-600 max-w-[250px]">
    <ErrorIcon className="w-[20px] h-[20px] fill-white" />
    <p className="p-0 m-0">{message}</p>
  </div>
)

const sendMail = async (data, setSubmitted) => {
  await fetch(`/send-email`, {
    method: `POST`,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(res => res.json())
    .then(body => {
      setSubmitted(true)
    })
}
